export enum LoginAction {
    LOGIN = 1,
    FIRST_ACCESS = 2,
    SEND_EMAIL_PASSWORD_RECOVERY = 3,
    CODE_CONFIRMATION_PASSWORD_RECOVERY = 4,
    CHANGE_PASSWORD = 5,
    LOGGED = 6
}